<template>
  <div class="stocks-banner">
    <div class="stocks-banner__picture">
      <DefImg :result="result.picture" />
    </div>
    <div class="stocks-banner__block">
      <div class="stocks-banner__description">
        <StocksLeft :result="result" :messages="messages" />
        <DefTimer v-if="result.endTime && !result.isOver" :result="{ endTime: result.endTime }" />
        <p v-else-if="!result.isOver" class="stocks-banner__day">
          {{ result.daysLeft }}
        </p>
      </div>
      <div class="stocks-banner__share">
        <span v-if="messages">
          {{ messages.share }}
        </span>
        <DefShare :result="result.shareLinks" />
      </div>
    </div>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import StocksLeft from '@components/Stocks/StocksLeft.vue';
import DefTimer from '@components/Def/DefTimer/DefTimer.vue';
import DefShare from '@components/Def/DefShare/DefShare.vue';

export default {
  name: 'StocksBanner',
  components: { DefShare, DefTimer, StocksLeft, DefImg },
  props: ['result', 'messages'],
};
</script>

<style lang="scss" scoped>
.stocks-banner {
  display: grid;
  margin-bottom: 32px;
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-bottom: 48px;
  }
  &:hover {
    :deep(.def-img) {
      transform: scale(1.1);
    }
  }
  &__picture {
    overflow: hidden;
  }
  &__block {
    display: flex;
    flex-direction: column;
    padding: 32px 16px;
    background-color: var(--background-light-pink);
    @include point-md {
      padding: 26px 20px;
    }
    @include point-lg {
      padding: 48px 60px;
    }
  }

  &__description {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding-bottom: 32px;
  }

  &__day {
    line-height: 100%;
    font-size: rem(24);
    @include point-md {
      font-size: rem(30);
    }
    @include point-lg {
      font-size: rem(48);
    }
  }

  &__share {
    display: flex;
    align-items: center;
    border-top: 1px dotted var(--background-grey);
    padding-top: 20px;
    @include point-lg {
      padding-top: 32px;
    }
    span {
      margin-right: 12px;
      font-size: rem(12);
    }
  }

  :deep(.def-share) {
    grid-column-gap: 12px;
  }

  :deep(.def-share__icon) {
    height: 16px;
    width: 16px;
  }

  :deep(.def-timer) {
    @include point-md {
      font-size: rem(30);
    }
    @include point-lg {
      font-size: rem(48);
    }
  }

  :deep(.stocks-left) {
    margin-bottom: 30px;
    @include point-lg {
      margin-bottom: 40px;
    }
  }
  :deep(.def-img) {
    transform-origin: center;
    transition: 0.2s linear transform;
  }
}
</style>
